<template>
  <a-card
      :title="'Wniosek'"
      style="max-width: 400px; margin: 0 auto; text-align: left"
  >
    <a-card-meta>
      <template #description>
        <p>{{ statusText }}</p>

        <transition name="list" tag="div">
          <div v-if="form.status === 'WAITING'">
            <VueLottiePlayer
                :animationData="require('@/assets/work-in-progress.json')"
                :width="'auto'"
                loop
                name="Work in progress"
                style="max-height: 300px; margin-top: 24px; margin-bottom: 24px"
            />
          </div>
        </transition>

        <small v-if="form.status === 'WAITING'">
          <strong>Średni czas oczekiwania:</strong> &lt; 1 dzień
        </small>
      </template>
    </a-card-meta>

    <template #extra>
      <a-badge :status="statusStyle"/>
    </template>

    <template slot="actions" class="ant-card-actions">
      <a-progress
          :percent="100"
          :showInfo="false"
          :status="progressStyle"
          style="padding: 0 1.8em"
      />
    </template>
  </a-card>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";
import httpClient from "@/utils/httpClient";

export default {
  data() {
    return {
      form: {
        status: "WAITING"
      }
    };
  },
  components: {
    VueLottiePlayer,
  },
  mounted() {
    let getStatusInterval = setInterval(() => {
      httpClient
          .get(`/identity/status`)
          .then((response) => {
            this.form.status = response.accountStatus;
            if (this.form.status !== "WAITING") {
              clearInterval(getStatusInterval);
            }
            if (this.form.status === "ACTIVE") {
              this.$emit("success");
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }, 3000);
  },
  computed: {
    statusText() {
      switch (this.form.status) {
        case "WAITING":
          return "Wniosek jest aktualnie weryfikowany przez administrację.";
        case "INACTIVE":
          return (
              "Wniosek został odrzucony. W celu poznania szczegółów skontaktuj się z administratorem."
          );
        case "ACTIVE":
          return "Wniosek został zaakceptowany! Odłącz kabel od urządzenia na 1 minutę.";
        default:
          return "Status nieznany.";
      }
    },
    statusStyle() {
      switch (this.form.status) {
        case "WAITING":
          return "processing";
        case "INACTIVE":
          return "exception";
        case "ACTIVE":
          return "success";
        default:
          return "normal";
      }
    },
    progressStyle() {
      switch (this.form.status) {
        case "WAITING":
          return "normal";
        case "INACTIVE":
          return "exception";
        case "ACTIVE":
          return "success";
        default:
          return "normal";
      }
    },
  },
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease-in-out;
  opacity: 1;
  height: 250px;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  height: 0;
}
</style>
